<template>
  <div v-if="questionsSubjectId" class="row px-4">
    <template v-for="item in questions">
      <div
        :key="item.questionId"
        :class="[
          'my-1',
          `${
            [questionsSubjectId['a.1'], questionsSubjectId['a.2']].includes(
              item.questionId
            )
              ? 'col-12 col-md-4 col-lg-3 col-xl-2'
              : 'col-12'
          }`,
        ]"
      >
        <div
          v-if="
            [questionsSubjectId['a.1'], questionsSubjectId['a.2']].includes(
              item.questionId
            )
              ? answeredQuestionIds.includes(questionsSubjectId.a)
              : true
          "
          :class="[
            {
              'pl-4': [
                questionsSubjectId['a.1'],
                questionsSubjectId['a.2'],
              ].includes(item.questionId),
            },
            {
              'w-100 d-xl-inline-flex align-items-center':
                item.questionId === questionsSubjectId.b,
            },
          ]"
        >
          <div>
            <CheckBox
              v-model="item.selected"
              :disabled="disabled"
              class="font-weight-light text-md-nowrap"
              :text="item.text"
              @input="input($event, item)"
            />

            <template v-if="item.questionId === questionsSubjectId.a">
              <ValidationProvider
                :ref="`checkbox_val_${item.questionId}`"
                name="Personal de apoyo a referir"
                v-slot="{ errors, validate: _validate }"
                :rules="{
                  required:
                    !disabled &&
                    validate &&
                    answeredQuestionIds.includes(questionsSubjectId.a)
                      ? { allowFalse: false }
                      : false,
                }"
                :custom-messages="{
                  required: 'Favor seleccione el personal de apoyo a referir.',
                }"
              >
                <input
                  :value="
                    answeredQuestionIds.includes(questionsSubjectId['a.1']) ||
                      answeredQuestionIds.includes(questionsSubjectId['a.2'])
                  "
                  type="hidden"
                  @validate="runValidation(_validate)"
                />
                <Error
                  v-if="errors[0]"
                  variant="no-border"
                  :message="errors[0]"
                />
              </ValidationProvider>
            </template>
          </div>

          <template
            v-if="
              questionsSubjectId.b && item.questionId === questionsSubjectId.b
            "
          >
            <div class="mt-2 mt-xl-0 ml-xl-3 w-100">
              <ValidationProvider
                name="Área a referir para evaluación o reevaluación"
                v-slot="{ errors }"
                :rules="{
                  required: answeredQuestionIds.includes(questionsSubjectId.b),
                }"
                :custom-messages="{
                  required:
                    'Favor escriba el área a referir para evaluación o reevaluación.',
                }"
              >
                <input
                  v-model="item.answers['9'].otherAnswerText"
                  :disabled="disabled"
                  type="text"
                  class="form-control"
                  @input="input(true, item)"
                />
                <Error
                  v-if="errors && errors[0]"
                  variant="no-border"
                  :message="errors[0]"
                />
              </ValidationProvider>
            </div>
          </template>
        </div>

        <div
          v-if="
            item.questionId === questionsSubjectId.c &&
              answeredQuestionIds.includes(questionsSubjectId.c)
          "
          class="mt-2"
        >
          <ValidationProvider
            name="Otra recomendación"
            v-slot="{ errors }"
            rules="required"
            :custom-messages="{ required: 'Favor escriba otra recomendación.' }"
          >
            <CustomTextArea
              v-model="item.answers['9'].otherAnswerText"
              :disabled="disabled"
              :maxlength="3000"
              show-char-count
              :count-classes="['d-block text-right']"
              @input="input(true, item)"
            />
            <Error
              v-if="errors && errors[0]"
              variant="no-border"
              :message="errors[0]"
            />
          </ValidationProvider>
          <ValidationProvider
            name="Explicación de la recomendación"
            v-slot="{ errors }"
            rules="required"
            :custom-messages="{ required: 'Favor explique la recomendación.' }"
          >
            <label class="font-weight-light">
              Explicación de la recomendación:
            </label>
            <CustomTextArea
              v-model="item.answers['16'].otherAnswerText"
              :disabled="disabled"
              :maxlength="3000"
              show-char-count
              :count-classes="['d-block text-right']"
              @input="input(true, item)"
            />
            <Error
              v-if="errors && errors[0]"
              variant="no-border"
              :message="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CheckBox from 'CheckBox';
import CustomTextArea from 'CustomTextArea';
import Error from 'custom-error';
import { tapRequestQuestionSectionsEnum } from '@/components/pei/ubication-tech-assistance/_types';

export default {
  name: 'ORERecommendations',
  components: { CheckBox, CustomTextArea, Error },
  props: {
    questionnaire: {
      type: Object,
      required: true,
      default: () => ({ questions: [] }),
    },
    answers: { type: Array, default: () => [] },
    validate: { type: Boolean, default: false },
    subject: {
      type: Number,
      default:
        tapRequestQuestionSectionsEnum.RecomendarCOMPUParaAnalisisFacilitador,
    },
    disabled: { type: Boolean, default: false },
  },
  data: () => ({ selectedQuestions: [] }),
  computed: {
    questionsSubjectId() {
      if (
        this.subject ===
        tapRequestQuestionSectionsEnum.RecomendarCOMPUParaAnalisisFacilitador
      ) {
        return {
          a: 229,
          'a.1': 230,
          'a.2': 231,
          b: 233,
          c: 236,
        };
      } else if (
        this.subject ===
        tapRequestQuestionSectionsEnum.RecomendarCOMPUParaAnalisisCSEE
      ) {
        return {
          a: 239,
          'a.1': 240,
          'a.2': 241,
          b: null,
          c: 247,
        };
      } else if (
        this.subject ===
        tapRequestQuestionSectionsEnum.OreRecomendacionNivelCentral
      ) {
        return {
          a: 250,
          'a.1': 251,
          'a.2': 252,
          b: null,
          c: 258,
        };
      }

      return null;
    },
    questions() {
      return (this.questionnaire?.questions || []).map((x) => ({
        questionId: x.id,
        text: x.text,
        selected: this.hasAnswer(x.id, x.answers[0].id),
        answers: x.answers.reduce(
          (z, y) => ({
            ...z,
            [y.id]: {
              answerId: y.id,
              parentId: y.validationName,
              otherAnswerText: this.getDescription(x.id, y.id),
            },
          }),
          {}
        ),
      }));
    },
    answers_sync() {
      return this.answers;
    },
    answeredQuestionIds() {
      return this.answers_sync.map((x) => x.questionId);
    },
  },
  methods: {
    runValidation(validateFn) {
      if (validateFn && typeof validateFn === 'function') {
        validateFn();
      }
    },
    hasAnswer(questionId, answerId) {
      return (
        this.answers_sync.findIndex(
          (x) => x.questionId === questionId && x.answerId === answerId
        ) >= 0
      );
    },
    getDescription(questionId, answerId) {
      return (
        this.answers_sync.find(
          (x) => x.questionId === questionId && x.answerId === answerId
        )?.otherAnswerText || null
      );
    },
    getDependentQuestions(questionId) {
      return this.questions.filter(
        (x) =>
          Object.values(x.answers).filter(
            (y) => y.parentId === `Q${questionId}Yes`
          ).length
      );
    },
    getParentQuestion(parentId) {
      return this.questions.filter((x) => `Q${x.questionId}Yes` === parentId);
    },
    input(checked, item) {
      const { questionId, answers } = item;

      if (checked) {
        Object.values(answers).map(
          ({ answerId, otherAnswerText, parentId }) => {
            const index = this.answers_sync.findIndex(
              (x) => x.questionId === questionId && x.answerId === answerId
            );
            if (index >= 0) {
              this.answers_sync.splice(index, 1, {
                questionId,
                answerId,
                otherAnswerText,
              });
            } else {
              this.answers_sync.push({ questionId, answerId, otherAnswerText });
            }

            if (parentId) {
              const parentQuestions = this.getParentQuestion(parentId);
              if (parentQuestions.length) {
                parentQuestions.map((x) => {
                  const index = this.answers_sync.findIndex(
                    (y) =>
                      y.questionId === x.questionId && y.answerId == answerId
                  );
                  if (index < 0) {
                    this.answers_sync.push({
                      questionId: x.questionId,
                      answerId,
                      otherAnswerText,
                    });
                  }
                });
              }
            }
          }
        );
      } else {
        this.answers_sync
          .filter((x) => x.questionId === questionId)
          .map((x) => {
            const index = this.answers_sync.findIndex(
              (y) => y.questionId === x.questionId
            );
            index >= 0 && this.answers_sync.splice(index, 1);
          });

        const dependentQuestions = this.getDependentQuestions(questionId);
        if (dependentQuestions.length) {
          dependentQuestions.map((x) => {
            const index = this.answers_sync.findIndex(
              (y) => y.questionId === x.questionId
            );
            index >= 0 && this.answers_sync.splice(index, 1);
          });
        }
      }
    },
    validateAnsweredDependent() {
      if (this.validate && !this.disabled) return;

      if (
        this.answeredQuestionIds.includes(this.questionsSubjectId.a) &&
        this.answeredQuestionIds.includes(
          this.questionsSubjectId['a.1'] ||
            this.answeredQuestionIds.includes(this.questionsSubjectId['a.2'])
        )
      ) {
        this.$refs[`checkbox_val_${this.questionsSubjectId.a}`][0].reset();
      }
    },
  },
  watch: {
    answeredQuestionIds: {
      handler() {
        this.validateAnsweredDependent();
      },
      deep: true,
    },
    answers_sync: {
      handler(value) {
        this.$emit('update:answers', value);
        this.$emit('input', value);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  ::v-deep .text-md-nowrap {
    white-space: nowrap !important;
  }
}
</style>
